<select *ngIf="isMobile$ | async; else desktop" (change)="setTimeSlot($event.target.value)">
  <option *ngFor="let item of items" [value]="item.index" [selected]="item.index === activeIndexFormControl.value">
    {{ item.intervalDisplay }}
  </option>
</select>

<ng-template #desktop>
  <sd-select>
    <ng-select
      bindLabel="intervalDisplay"
      bindValue="index"
      [items]="items"
      [searchable]="false"
      [clearable]="false"
      [formControl]="activeIndexFormControl"
      (change)="setTimeSlot($event.index)"
    ></ng-select>
  </sd-select>
</ng-template>
